
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { PhoneNumberInput } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';
import { ControlledField } from '../utils';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Phone Number Input`}</h1>
<p>{`Used in forms to set a phone number. Includes a select to change the number prefix with country flag emojis.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { PhoneNumberInput } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Note`}</strong>{`
Because the phone number prefix is automatically applied to the input when the component loads, we can't easily check if the value is empty or not in the form control. Thus the component exposes a utility function `}<inlineCode parentName="p">{`getTrailingPhoneNumber`}</inlineCode>{` which returns the number without the prefix.`}</p>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<ControlledField initialValue="" style={{ width: 300 }} component={
  <PhoneNumberInput placeholder="+32 47 123 45 56" value="" />
} />`} component={PhoneNumberInput} mdxType="Playground">
  <ControlledField initialValue="" style={{
        width: 300
      }} component={<PhoneNumberInput placeholder="+32 47 123 45 56" value="" mdxType="PhoneNumberInput" />} mdxType="ControlledField" />
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;